// @ts-nocheck

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {
  addLocalizationQuery,
  fetchLocalizationByIdQuery,
  fetchLocalizationTableQuery,
  removeLocalizationQuery,
  updateLocalizationQuery,
} from "../../api/localizationApi";


export const getLocalization = createAsyncThunk(
  "localization/getLocalization",
  async (
    { page, limit, lan }: { page: number; limit: number; lan: string },
    { dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());

    try {
      return await fetchLocalizationTableQuery(page, limit, lan);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getLocalizationById = createAsyncThunk(
  "localization/getLocalizationById",
  async (
    { id, lan }: { id: string; lan: string },
    { dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());

    try {
      return await fetchLocalizationByIdQuery(id, lan);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createLocalization = createAsyncThunk(
  "localization/createLocalization",
  async (
    newLocalization: { language: string; key: string; value: string },
    { dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());

    try {
      return await addLocalizationQuery(newLocalization);
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const editLocalization = createAsyncThunk(
  "localization/editLocalization",
  async (
    {
      id,
      lan,
      key,
      value,
    }: {
      id: string;
      lan: string;
      key?: string;
      value?: string;
    },
    { dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());

    try {
      return await updateLocalizationQuery(id, { key, value }, lan);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteLocalization = createAsyncThunk(
  "localization/deleteLocalization",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await removeLocalizationQuery(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);


const localizationSlice = createSlice({
  name: "localization",
  initialState: {
    localizations: [] as any[],
    localization: null as any | null,
    status: null as boolean | null,
    msg: "",
    total:0,
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        getLocalization.fulfilled,
        (state, action: PayloadAction<any[]>) => {
          state.status = true;
          // console.log(action.payload,'action.payload')
          state.localizations = action.payload.data;
          state.total = action.payload.pagination.total;
        }
      )
      .addCase(getLocalization.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      .addCase(
        getLocalizationById.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.status = true;
          state.localization = action.payload.data;
        }
      )
      .addCase(getLocalizationById.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
        state.localization = null;

      })

      .addCase(
        createLocalization.fulfilled,
        (state, action: PayloadAction<any>) => {
          if (Array.isArray(state.localizations)) {
            state.localizations.push(action.payload);
            state.status = true;
            state.msg = "Localization created successfully.";
          }
        }
      )

      .addCase(
        editLocalization.fulfilled,
        (state, action: PayloadAction<any>) => {
          const { id, data } = action.payload;
          const index = state.localizations.findIndex((item) => item.id === id);
          if (index !== -1) {
            state.localizations[index] = data;
          }
          state.status = true;
          state.msg = "Localization updated successfully.";
        }
      )

      .addCase(
        deleteLocalization.fulfilled,
        (state, action: PayloadAction<string>) => {
          state.localizations = state.localizations.filter(
            (item) => item.id !== action.payload
          );
          state.status = true;
          state.msg = "Localization deleted successfully.";
        }
      );
  },
});

export const { resetStatus } = localizationSlice.actions;
export default localizationSlice.reducer;
